import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loader-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteLogo = _resolveComponent("SiteLogo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BasePage = _resolveComponent("BasePage")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_BasePage, null, {
    menu: _withCtx(() => [
      _createVNode(_component_SiteLogo)
    ]),
    "page-body": _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
        [_directive_loading, _ctx.controlLoading]
      ]),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}